import { render, staticRenderFns } from "./NoPage.vue?vue&type=template&id=17f80a00&"
import script from "./NoPage.vue?vue&type=script&lang=ts&"
export * from "./NoPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports